/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const ManageKeyPer = () => {
  const [data, setData] = useState([]);
  const [keyId, setKeyId] = useState("");
  const [inputKeyValue, setInputKeyValue] = useState("");
  const [contact, setContact] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validInputKey, setValidInputKey] = useState("key");
  const [validContact, setValidContact] = useState("contact");
  const [regexContact, setRegexContact] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterText, setFilterText] = useState("");

  const validateContact = (value) => {
    const regex = new RegExp(/^[0-9]{10}$/);
    return regex.test(value);
  };

  const handleContactChange = (e) => {
    const isValidContact = validateContact(e.target.value);
    setContact(e.target.value);
    setRegexContact(isValidContact);
    setValidContact(e.target.value);
  };
  const validateForm = () => {
    let valid = false;
    if (inputKeyValue === "") {
      setValidInputKey(inputKeyValue);
      valid = true;
    }
    const isValidContact = validateContact(contact);
    if (contact === "") {
      setValidContact(contact);
      valid = true;
    } else if (isValidContact === false) {
      setRegexContact(isValidContact);
      valid = true;
    }
    return valid;
  };

  const handleEditData = (value) => {
    setIsModalOpen(true);
    setEditMode(true);
    setKeyId(value.id);
    setInputKeyValue(value.nameOfKey);
    setContact(value.contact);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setEditMode(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setValidInputKey("key");
    setValidContact("contact");
    setInputKeyValue("");
    setContact("");
    setRegexContact(true);
  };

  const handleDeleteKey = async (id) => {
    try {
      await axios
        .delete(`${process.env.REACT_APP_API_URL}/delete-keyperson/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        })
        .then((res, error) => {
          if (res.status === 200) {
            handleData();
            toast.success(res.data.message);
          }
        });
    } catch (error) {
      console.error("Error deleting key person:", error);
      if (error.response.status === 500) {
        toast.error("This Key person is not deleted");
      }
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setFilterText("");
    }
  };

  const handleSearchClick = () => {
    setFilterText(searchTerm);
  };

  const handleSave = async () => {
    if (!validateForm()) {
      if (editMode) {
        try {
          const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/update-key-person/${keyId}`,
            {
              nameOfKey: inputKeyValue,
              contact: contact,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
              },
            }
          );

          if (response.status === 201) {
            setIsModalOpen(false);
            setInputKeyValue("");
            setContact("");
            handleData();
          }
        } catch (error) {
          console.error("Error submitting KeyPerson data:", error);
        }
      } else {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/create-key-person`,
            {
              nameOfKey: inputKeyValue,
              contact: contact,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
              },
            }
          );

          if (response.status === 201) {
            setIsModalOpen(false);
            setInputKeyValue("");
            setContact("");
            handleData();
          }
        } catch (error) {
          console.error("Error submitting KeyPerson data:", error);
        }
      }
    }
  };

  const handleData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-person-detials?search=${filterText}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      }
    );
    setData(response.data?.result);
  };

  useEffect(() => {
    handleData();
  }, [filterText]);
  return (
    <div id="main" className="main">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ flex: "1", marginLeft: "15px" }}>Key Person Master</h2>
        <div className="search-wrapper">
          <input
            className="form-control  me-2"
            type="search"
            value={searchTerm}
            onChange={handleChange}
            placeholder="Search key persons, contact..."
          />
          <button className="btn btn-dark me-2" onClick={handleSearchClick}>
            Search
          </button>
        </div>
        <button
          className="btn btn-dark"
          style={{ marginRight: "17px" }}
          onClick={handleOpenModal}
        >
          <i className="bi bi-plus-lg"></i> Key Person
        </button>
      </div>
      <div className="col-lg-12">
        <div className="card mb-8">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Name of key</th>
                    <th>Contact</th>
                    <th className="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((value, index) => (
                    <tr key={index}>
                      <td>{value?.nameOfKey}</td>
                      <td>{value?.contact}</td>
                      <td
                        className="text-end"
                        style={{ verticalAlign: "middle" }}
                      >
                        <a
                          style={{ marginRight: "8px", cursor: "pointer" }}
                          onClick={() => handleDeleteKey(value.id)}
                        >
                          <i className="bi bi-trash3"></i>
                        </a>
                        <a
                          style={{ marginRight: "8px", cursor: "pointer" }}
                          onClick={() => handleEditData(value)}
                        >
                          <i className="bi bi-pencil"></i>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal show={isModalOpen} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editMode === true ? "Edit Key Person" : "Add Key Person"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name of Key</Form.Label>
              <Form.Control
                className={`form-control ${
                  validInputKey === "" && "is-invalid"
                }`}
                type="text"
                name="nameOfKey"
                value={inputKeyValue}
                onChange={(e) => {
                  setInputKeyValue(e.target.value);
                  setValidInputKey(e.target.value);
                }}
              />
              {validInputKey === "" && (
                <p className="invalid-feedback">Name of Key is required</p>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Contact Number</Form.Label>
              <Form.Control
                className={`form-control ${
                  (validContact === "" || regexContact === false) &&
                  "is-invalid"
                }`}
                type="number"
                name="contact"
                value={contact}
                onChange={handleContactChange}
              />
              {validContact === "" ? (
                <div className="invalid-feedback">
                  Contact Number is required
                </div>
              ) : (
                <div className="invalid-feedback">
                  Contact Number must be exactly 10 digits
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageKeyPer;
